import PropTypes from 'prop-types'

const ControlHelpContent = ({ itemsPerSet, maxDiffType }) => (
  <>
    <p>Results of the Advanced MaxDiff experiment can be viewed in several ways:</p>
    <br />
    {3 === itemsPerSet && (
      <p>
        <b>Preference Likelihood (3/screen)</b> represents the likelihood that an item would be preferred over 2 other
        randomly selected items in the set. This score is appropriate when the MaxDiff exercise shows 3 items per
        exposure.
      </p>
    )}
    {4 === itemsPerSet && (
      <p>
        <b>Preference Likelihood (4/screen)</b> represents the likelihood that an item would be preferred over 3 other
        randomly selected items in the set and is appropriate when the MaxDiff shows 4 items per exposure.
      </p>
    )}
    {5 === itemsPerSet && (
      <p>
        <b>Preference Likelihood (5/screen)</b> represents the likelihood that an item would be preferred over 4 other
        randomly selected items in the set and is appropriate when the MaxDiff shows 5 items per exposure.
      </p>
    )}
    <br />
    <p>
      <b>Average-based PL (50% baseline)</b> represents the Preference likelihood [PL] that an item would be preferred
      over one other randomly selected item in the set. A score above 50% indicates that an item is a
      better-than-average performer.
    </p>
    <br />
    <p>
      <b>Utility Scores</b> are the raw regression coefficients{' '}
      {0 === maxDiffType ? 'estimated at the aggregate level' : 'averaged across individuals'}. They are zero-centered
      so that 0 represents the average performance. The more positive an item&apos;s utility, the more it is preferred
      by respondents and the more negative an item&apos;s utility, the less it is preferred.
    </p>
    <br />
    <a
      href="https://helpcenter.aytm.com/hc/en-us/articles/8458906560269-Analyzing-an-Advanced-MaxDiff"
      target="_blank"
      rel="noreferrer"
    >
      Learn more &raquo;
    </a>
  </>
)

ControlHelpContent.propTypes = {
  itemsPerSet: PropTypes.number,
  maxDiffType: PropTypes.number
}

export default ControlHelpContent
